
import React, { useMemo, useEffect } from 'react'
import { AppBody, AppBodyBailleur, AppContainer, AppContent } from '../../../styles/App.styled';
import { Navigate, Route, useLocation, Routes, useNavigate } from 'react-router-dom';
import Menu from '../../Menu/Menu'
import HomeIcon from '@mui/icons-material/Home';
import SaveIcon from '@mui/icons-material/Save';
import Header from '../../../components/Header/Header'
import { useTranslation } from 'react-i18next';
import Campaigns from '../../Campaigns/Campaigns';
import CampaignForm from '../../CampaignForm/CampaignForm';
// import WalletIcon from '@mui/icons-material/Wallet';
import UserForm from '../../UserForm/UserForm';
import Entity from '../../Entity/Entity';
import UserEntity from "../../UserForm/UserEntity"
import PdfViewerPage from "../../PdfViewerPage/PdfViewerPage"
import logoYounov from '../../../assets/images/Logo-Younov.png';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions/index';

function ClientRoot({ userRoles, userType, BailleurId, URL }) {

    const navigate = useNavigate()
    const Referrer = localStorage.getItem("parentLocation")?.split('/')?.pop();
    useEffect(() => {
        let nav = Referrer ? "/" + Referrer : "/";
        if (["showGuideProduction", "showGuideTeledeclaration"].includes(Referrer))
            navigate(nav)
        else
            navigate('/entity/' + BailleurId)
    }, [BailleurId])

    const menuItems = useMemo(() => (
        [
            { isLink: true, key: 'TableauBord', label: "Tableau de bord", pathname: `${URL}/Bailleur/TableauBord`,  icon: <SaveIcon /> },
            { isLink: true, key: 'Consultation', label: "Consultation", pathname: `${URL}/Bailleur/Consultation`, icon: <SaveIcon /> },
            { isLink: true, key: 'Administration', label: "Administration", pathname: '/entity/' + BailleurId, icon: <SaveIcon /> },
        ]
    ), [BailleurId, URL])

    const submenu = () => {
        let menuTemp = menuItems;
        let temp = menuTemp.filter(item => item !== false)
        let menu = temp.map(item => {
            if (item.subMenu !== undefined) {
                return { ...item, subMenu: item.subMenu.filter(item => item !== false) }
            } else {
                return item
            }
        })
        return menu
    }

    return (
        <>
            <AppContainer>
                {/*<div style={{ display: "flex", justifyContent: "center", color: "white", backgroundColor: "#82d616", height: "25px", alignItems: "center" }}>ENVIRONNEMENT éé DE DEVELOPMENT</div>*/}
                <div style={{ display: "flex", justifyContent: "center", height: "100px", alignItems: "center" }}>
            
                    <Header isEnqueteSatisfaction={false} />
                  
                </div>
              
                <AppBodyBailleur>
                    <Menu items={submenu()} userType={userType} bailleurId={BailleurId} />
                    <AppContent >
                        <Routes>
                           
                            <Route path="/entity/:uid" element={<Entity  />} />                           
                            <Route path="/entity" element={<Entity />} />
                            <Route path="/userForm/:uid" element={<UserForm />} />
                            <Route path="/userForm" element={<UserForm />} />                         
                            <Route path="/suiviCampagnes" element={<Campaigns />} />
                            <Route path="/newCampaign" element={<CampaignForm />} />
                            <Route path="/newCampaign/:uid" element={<CampaignForm />} />
                            <Route path="/userEntity/:uid" element={<UserEntity />} />
                            <Route path="/userEntity" element={<UserEntity />} />
                            <Route path="/showGuideTeledeclaration" element={<PdfViewerPage />} />
                            <Route path="/showGuideProduction" element={<PdfViewerPage />} />

                            
                             <Route path="/" element={<></>} />
                        </Routes>
                    </AppContent>

                </AppBodyBailleur>
                <div style={{ display: "flex", justifyContent: "center", height: "60px", alignItems: "center", borderTop: "1px solid #e5e5e5" }}>

                    <div style={{ display: "flex", alignItems: "end", fontSize: "1rem" }}>
                        <p style={{ color: "#67748e" }}>
                            &nbsp; {("default:copyright", `  ©${new Date().getFullYear()} - Créé par  `)}
                        </p>
                        <p style={{ color: "#0077cc" }}>
                            &nbsp; Younov
                        </p>
                       
                    </div>

                </div>
            </AppContainer>
        </>
    )
}

const mapStateToProps = state => {
    return {
        userType: state.auth.userType,
        logo: state.auth.logo,
        URL: state.auth.URL,
    }
}
const mapDispatchToProps = dispatch => {
    return {
       
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientRoot);
